/*
 * @Description: 终端要货
 * @Autor: txp
 * @Date: 2021-05-12 16:55:57
 */
import request from "@/utils/request";
// 1.终端要货列表
export const OrderDetailEs = (data) =>request.post('/sfa/sfaTerminalOrderController/findList',data)
// 2.终端要货列表查询详情
export const SfaWorkDailyController = (data) =>request.get('/sfa/sfaTerminalOrderController/getProductListByOrderId',data)
// 3.终端要货列表取消/确认订单
export const ChangeOrderStatus = (data) =>request.post('/sfa/hdSfaVisitStepOrderForm/changeOrderStatus',data)




